import { defaultEmbedContextOptions, EmbedContext, } from '@thoughtspot/blink-context';
import React, { useMemo } from 'react';
import { useAdminContext } from "../../contexts/context";
import { PinboardContextType } from "../../services/generated/graphql-types";
import { create } from "../../utils/logger";
import { parseIdProp } from './common';
import styles from './liveboard-embed-custom.module.scss';
const logger = create('Admin.LiveboardEmbedCustom');
const LiveboardEmbedCustom = ({ Id }) => {
    const { pinboardId, tabId } = parseIdProp(Id);
    const { blinkComponents } = useAdminContext();
    const LiveboardContainer = blinkComponents?.LiveboardContainer;
    const embedConfig = useMemo(() => ({
        ...defaultEmbedContextOptions,
        isEmbedded: true,
        isPoweredFooterHidden: true,
        embedParams: {
            ...defaultEmbedContextOptions.embedParams,
            hideLiveboardHeader: false,
            hideTabPanel: false,
        },
    }), []);
    if (!LiveboardContainer) {
        logger.error('LiveboardEmbedCustom: LiveboardContainer is not available in blinkComponents context');
        return null;
    }
    return (React.createElement(EmbedContext.Provider, { value: embedConfig },
        React.createElement("div", { className: styles.liveboardEmbed },
            React.createElement(LiveboardContainer, { pinboardId: pinboardId, tabId: tabId, pinboardContext: PinboardContextType.AdminPinboard }))));
};
export default LiveboardEmbedCustom;
//# sourceMappingURL=liveboard-embed-custom.container.js.map